const DEFAULT_STATE = { timestamp: +new Date() };

//
// Action types
//

export const RESET_CAPTCHA = "RESET_CAPTCHA";

//
// Action creators
//

export function resetCaptcha() {
  return {
    type: RESET_CAPTCHA
  };
}

function resetCaptchaHandler() {
  return { timestamp: +new Date() };
}

//
// Reducer and handlers
//
export default function captchaReducer(state, action) {
  switch (action && action.type) {
    case RESET_CAPTCHA:
      return resetCaptchaHandler();

    default:
      return state || DEFAULT_STATE;
  }
}
